const pathnames = {
    VUE_MEMBER_H5: '/h5/', // 加密货币问卷，需传 cltId
}
Object.entries(pathnames).forEach(([k, v]) => {
    Object.defineProperty(pathnames, k, {
        get() {
            if (/^http(s)?/.test(v)) return v
            let origin = location.origin
            // 开发状态下 origin默认跳转到sit域名，方便查看跳转是否正确
            if (process.env.NODE_ENV === 'development') {
                // origin = 'https://member-sit.efinshares.com'
                const { VUE_APP_ESOP_H5 } = process.env
                origin = VUE_APP_ESOP_H5
            } else {
                const { VUE_APP_ESOP_H5 } = process.env
                origin = VUE_APP_ESOP_H5
            }
            console.log('VUE_ESOP', origin)

            return `${origin}${v}`
        },
        enumerable: false,
        configurable: false,
    })
})

export default pathnames
